<template>
  <div>
    <Header />
    <v-container>
      <v-layout class="my-4" wrap>
        <v-flex>
          <h1>Listado de Pernoctas</h1>
        </v-flex>
      </v-layout>
      <v-layout class="my-4" wrap>
        <v-flex d-flex justify-end>
          <v-btn tile color="primary" v-on:click="addPernocta">
            <v-icon left> mdi-plus </v-icon>
            Crear Pernocta
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout class="my-4" wrap>
        <!--Fechas -->
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <label for="desde"><b>Fecha Desde</b></label>
            <input
              type="date"
              name="hasta"
              id="desde"
              v-model="dataFiltros.desde"
              class="v-input theme--light v-text-field v-text-field--is-booted v-input__slot v-text-field__slot filtros"
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="3">
            <label for="desde"><b>Fecha Hasta</b></label>
            <input
              type="date"
              name="hasta"
              id="hasta"
              v-model="dataFiltros.hasta"
              class="v-input theme--light v-text-field v-text-field--is-booted v-input__slot v-text-field__slot filtros"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" class="mt">
            <v-select v-if="userData.rol_id == 2"
              v-model="dataFiltros.colaborador_id"
              :items="colaboradores"
              item-text="nombre"
              item-value="id"
              label="Monitor"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="mt">
            <v-flex d-flex justify-start>
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="primary"
                v-on:click="listarPernoctas"
              >
                <v-icon dark> mdi-magnify </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="primary"
                v-on:click="resetFiltros"
              >
                <v-icon dark> mdi-backspace-outline </v-icon>
              </v-btn>
            </v-flex>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <!--Fechas -->
      </v-layout>

      <v-layout class="my-5" wrap v-if="showBarProgress == true">
        <v-progress-linear
          indeterminate
          color="deep-orange darken-4"
        ></v-progress-linear>
      </v-layout>

      <v-layout class="my-5" wrap>
        <v-flex>
          <v-data-table
            :headers="headers"
            :items="pernoctas"
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:item.acciones="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editPernoctas(item.id)"
                color="green darken-2"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <Footer />
  </div>
</template> 
<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Footer,
  },    
  data() {
    return {
      showBarProgress:false,
      userData: {},
      httpHeaderAuthorization: "",
      pernoctas: [],   
      dataFiltros: {
        desde: "",
        hasta: "",
        colaborador_id: ""
      },         
      headers: [
        {
          text: "Fecha",
          align: "start",
          sortable: false,
          value: "fecha",
        },
        { text: "Hora", value: "hora" },
        { text: "Semana", value: "semana" },
        { text: "Colaborador", value: "colaborador" },
        { text: "Colecta(Numero Ejemplares)", value: "colecta" },
        { text: "Sitio", value: "sitio" },
        { text: "Latitud", value: "latitud" },
        { text: "Longitud", value: "longitud" },
        { text: "Planta Pernocta", value: "planta_pernocta" },
        { text: "Acciones", value: "acciones", sortable: false },
      ],
      colaboradores: []
    };
  },
  mounted() {
    //this.httpHeaderAuthorization = `Bearer ${localStorage.access_token}`;
    this.userData = JSON.parse(localStorage.datos_usuario);
    this.listarPernoctas();
    if(this.userData.rol_id == 2){
      this.obtenerColaboradores();
    }

  },
  created() {
    if (localStorage.getItem("access_token") === null) {
      this.$router.push("/");
    }
  },
  methods: {
    addPernocta() {
      this.$router.push("nueva-pernocta");
    },
    editPernoctas(item) {
      console.log(item)
      this.$router.push({
          path: `/editar-pernocta/${item}`
      })
    },
    listarPernoctas() {
      this.showBarProgress = true
      this.pernoctas = [];
      this.httpHeaderAuthorization = `Bearer ${localStorage.access_token}`;

      let url = `${this.$apiUrl}/api/pernocta?desde=${this.dataFiltros.desde}&hasta=${this.dataFiltros.hasta}&colaborador_id=${this.dataFiltros.colaborador_id}`;

      axios
        .get(url, { headers: { Authorization: this.httpHeaderAuthorization } })
        .then((data) => {
          let result = data.data;
          result.forEach((element) => {
            this.pernoctas.push({
              id:element.id,
              fecha: element.fecha,
              hora: element.hora,
              semana: element.semana,
              colaborador: element.nombre,
              colecta: element.numero_ejemplares,
              sitio: element.sitio,
              latitud: element.latitud,
              longitud: element.longitud,
              planta_pernocta: element.planta_pernocta
            });
          });
          this.showBarProgress = false
        })
        .catch((error) => {
          if (error.response.status === 401){
            this.cerrarSession()
          }
        });
    },
    obtenerColaboradores() {
      axios
        .get(`${this.$apiUrl}/api/colaboradores`, {
          headers: { Authorization: this.httpHeaderAuthorization },
        })
        .then((data) => {
          let result = data.data;
          result.forEach((element) => {
            this.colaboradores.push({
              id: element.id,
              nombre: element.nombre,
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetFiltros() {
      this.dataFiltros.desde = "";
      this.dataFiltros.hasta = "";
      this.dataFiltros.colaborador_id = "";
    },    

  },
};
</script>  